import React, {Component} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {setCompanyData} from "../../redux/register/action";
import {checkFields, CheckPassword, emptyFields, StateSetterValidator, ValidateEmail} from "../../utils/Validators";
import axios from "axios"
import {GoogleApiWrapper} from "google-maps-react";
import RegisterAddressInput from "./RegisterAddressInput";
import {CustomInput, CustomInputField, ErrorIndicatorDiv} from "../Inputs";
import {BackgroundDiv} from "../Containers";
import FieldError from "../FieldError";

const REQUIRED_FIELDS = ['companyName',]


class CompanyRegisterForm extends Component {


    componentDidMount() {
        this.renderAutoComplete();
    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps.map) this.renderAutoComplete();


        const register = this.props.companyRegister
        console.log(!register.companyAddressError)
        console.log(!(register.companyAddress.address_components.length > 5))
        StateSetterValidator([
                !!register.companyName,
                !register.companyNameError,

                !!register.companyAddress,
                !!register.companyAddress.address_components,
                !(register.companyAddress.address_components.length < 5),
                !register.companyAddressError,

            ],
            register.formFilled,
            () => {
                this.props.setCompanyData({formFilled: !register.formFilled})
            }
        )

    }

    async renderAutoComplete() {
        const {google} = await this.props;
        if (!google) return;

        const autocomplete = await new google.maps.places.Autocomplete(this.autocomplete);

        await autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            if (place && place.geometry && place.geometry.location) {
                this.props.setCompanyData({
                    companyAddress: {
                        formatted_address: place.formatted_address,
                        address_components: place.address_components,
                        location: {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                        }
                    }
                })
            }

        });
    }


    changeValue = (e) => {
        this.props.setCompanyData({
            [e.target.id]: e.target.value,
        })
    }

    render() {

        //console.log(this.props)

        const {address_components} =
            this.props.companyRegister.companyAddress ?
                this.props.companyRegister.companyAddress
                :
                false

        return (
            <div>
                <CustomInput
                    type="text"
                    id={'companyName'}
                    placeholder={'cég neve'}
                    value={this.props.companyRegister.companyName}
                    textTransform={'none'}
                    onChange={(e) => this.changeValue(e)}
                    error={this.props.companyRegister.companyNameError}
                />
                <br/>
                <div style={{position: 'relative'}}>
                    <CustomInputField
                        type="text"
                        placeholder="Telephely címe"
                        id={'companyAddressInput'}
                        ref={ref => (this.autocomplete = ref)}
                        onChange={this.changeValue}
                        style={{
                            position: 'relative',
                            zIndex: 1,
                            width: '80%',
                            margin: '1rem auto'
                        }}
                    />
                    {this.props.companyRegister.companyAddressError ?
                        <ErrorIndicatorDiv
                            style={{
                                zIndex: '2',
                                width: '80%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                            }}
                        />
                        :
                        null
                    }
                    <FieldError error={this.props.companyRegister.companyAddressError}/>
                </div>


                <br/>
                <div style={{position: 'relative', height: '100%'}}>
                    <RegisterAddressInput
                        address_components={address_components}
                        fieldNameEN={'postal_code'}
                        fieldNameHU={'Irányítószám'}
                    />
                    <RegisterAddressInput
                        address_components={address_components}
                        fieldNameEN={"locality"}
                        fieldNameHU={'Város'}/>

                    <RegisterAddressInput
                        address_components={address_components}
                        fieldNameEN={'route'}
                        fieldNameHU={'Utca'}/>

                    <RegisterAddressInput
                        address_components={address_components}
                        fieldNameEN={"street_number"}
                        fieldNameHU={'Házszám'}/>

                    <RegisterAddressInput
                        address_components={address_components}
                        fieldNameEN={"country"}
                        fieldNameHU={'Ország'}/>


                </div>


            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyRegister: state.companyRegister
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setCompanyData: (data) => dispatch(setCompanyData(data, true)),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    GoogleApiWrapper({
        apiKey: ('AIzaSyArAZSgfZJcC_KiXv4s_WAUPhJnyA8De8s')
    })
)(CompanyRegisterForm);